import LoadingComponent from "@tracking/core/LoadingComponent";
import ModalError from "@tracking/core/ModalError";
import ModalAttachment from "@tracking/core/ModalAttachment";
import Toast from "@tracking/core/Toast";
import TrackingDialog from "@tracking/core/TrackingDialog";
import React from "react";

const NotificationSystem: React.FC = () => {
  return (
    <>
      <LoadingComponent />
      <ModalError />
      <ModalAttachment />
      <Toast />
      <TrackingDialog />
    </>
  );
};

export default NotificationSystem;
